import { render } from "./CoinExchangeView.vue?vue&type=template&id=4c9c2098&scoped=true&lang=pug"
import script from "./CoinExchangeView.vue?vue&type=script&lang=js"
export * from "./CoinExchangeView.vue?vue&type=script&lang=js"

import "./CoinExchangeView.vue?vue&type=style&index=0&id=4c9c2098&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c9c2098"]])

export default __exports__